export function initLocalDateTime() {
  document.querySelectorAll("[local-datetime]").forEach((element) => {
    updateDateTimeIn(element as HTMLElement);
  });
}

function updateDateTimeIn(element: HTMLElement) {
  const datetime = element.getAttribute("datetime");
  const format = element.getAttribute("local-datetime-format") || "long-datetime";

  if (!datetime) {
    console.error("datetime must be provided for local-datetime");
    return;
  }

  element.innerHTML = formatDateTime(new Date(datetime), format);
}

function formatDateTime(date: Date, format: string): string {
  const locale = "en-US";

  if (format == "long-datetime") {
    const datePart = date.toLocaleDateString(locale, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const timePart = date.toLocaleTimeString(locale);

    return `${datePart}, ${timePart}`;
  } else if (format == "short-datetime") {
    const day = date.toLocaleDateString(locale, { day: "numeric" });
    const month = date.toLocaleDateString(locale, { month: "short" });
    const year = date.toLocaleDateString(locale, { year: "numeric" });
    const time = date.toLocaleTimeString(locale, { hour: "numeric", minute: "numeric" });

    return `${month} ${day}, ${year}, ${time}`;
  } else {
    console.error(`Unknown format for local-datetime: ${format}`);
    return formatDateTime(date, "long-datetime");
  }
}

document.addEventListener("DOMContentLoaded", initLocalDateTime);
